/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free reverse complement tool. Paste a DNA or RNA sequence to get its reverse complement, complement or reverse. IUPAC ambiguity codes supported; FASTA input accepted.`)
};

const es_revcomp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramienta gratuita de complemento inverso. Pega una secuencia de ADN o ARN para obtener su complemento inverso, complemento o inverso. Admite códigos de ambigüedad IUPAC; acepta entrada en formato FASTA.`)
};

const de_revcomp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses Tool für das reverse Komplement. Fügen Sie eine DNA- oder RNA-Sequenz ein, um ihr reverses Komplement, Komplement oder ihre Umkehrung zu erhalten. IUPAC-Mehrdeutigkeitscodes werden unterstützt; FASTA-Eingabe wird akzeptiert.`)
};

const nl_revcomp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis omgekeerd-complementtool. Plak een DNA- of RNA-sequentie om het omgekeerde complement, complement of de omkering te krijgen. IUPAC-ambiguïteitscodes ondersteund; FASTA-invoer geaccepteerd.`)
};

const fr_revcomp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outil gratuit de complément inverse. Collez une séquence d'ADN ou d'ARN pour obtenir son complément inverse, son complément ou son inverse. Codes d'ambiguïté IUPAC pris en charge ; entrée FASTA acceptée.`)
};

const it_revcomp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumento gratuito per il complemento inverso. Incolla una sequenza di DNA o RNA per ottenere il suo complemento inverso, complemento o inverso. Supporta i codici di ambiguità IUPAC; accetta input FASTA.`)
};

const pt_br2_revcomp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita de complemento reverso. Cole uma sequência de DNA ou RNA para obter seu complemento reverso, complemento ou reversão. Suporta códigos de ambiguidade IUPAC; aceita entrada em FASTA.`)
};

const pt_revcomp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita de complemento reverso. Cole uma sequência de ADN ou ARN para obter o seu complemento reverso, complemento ou reverso. Suporta códigos de ambiguidade IUPAC; aceita entrada FASTA.`)
};

const ja_revcomp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の逆相補配列ツール。DNAまたはRNA配列を貼り付けると、逆相補配列、相補配列、逆順配列が得られます。IUPAC縮重コード対応、FASTA入力可。`)
};

const zh_revcomp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费反向互补工具。粘贴 DNA 或 RNA 序列即可获得其反向互补、互补或反向序列。支持 IUPAC 简并码；接受 FASTA 输入。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_meta_description", locale)
	if (locale === "en") return en_revcomp_meta_description(inputs)
	if (locale === "es") return es_revcomp_meta_description(inputs)
	if (locale === "de") return de_revcomp_meta_description(inputs)
	if (locale === "nl") return nl_revcomp_meta_description(inputs)
	if (locale === "fr") return fr_revcomp_meta_description(inputs)
	if (locale === "it") return it_revcomp_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_meta_description(inputs)
	if (locale === "pt") return pt_revcomp_meta_description(inputs)
	if (locale === "ja") return ja_revcomp_meta_description(inputs)
	return zh_revcomp_meta_description(inputs)
};